export const DAO_CODE = 'OFFICE_DAO';